/**
 * CLARTEXT · Fuehrerscheinkontrolle · Block C — Fahrzeug-Piktogramm-Mapper.
 *
 * Ausschliesslich technische Zuordnung `pictogram_key -> statischer Bildpfad`.
 * Keine zweite fachliche Wahrheit ueber Fahrzeugkategorien: `identifier`,
 * `display_name`, `orientation_hint`, `pictogram_alt_text`, `sort_order`
 * kommen ausschliesslich vom Backend-Endpoint
 * `GET /api/fuehrerschein/vehicle-categories`, dessen Quelle wiederum der
 * eingefrorene Vertrag `services/fuehrerschein/vehicle_category_contract.py`
 * ist.
 *
 * Die sechs `pictogram_key`-Werte sind byte-eingefroren (Block B). Die
 * jeweilige Bild-Datei liegt in `frontend/public/pictograms/` und ist
 * ueber den Public-Pfad `/pictograms/<key>.png` erreichbar.
 *
 * BE-002: KEIN Klassenzusatz, KEIN FeV-/StVZO-Bezug, keine Compliance-
 * Ableitung. Reine Anzeige.
 */

const PICTOGRAM_BASE_PATH = "/pictograms";

// Byte-eingefrorene Zuordnung. Muss deckungsgleich mit den 6 pictogram_key-
// Werten aus dem Backend-Vertrag sein und den 6 Dateien in public/pictograms/.
const PICTOGRAM_FILE_BY_KEY = Object.freeze({
  pkw: "pkw.png",
  pkw_anhaenger: "pkw_anhaenger.png",
  transporter: "transporter.png",
  lkw_klein: "lkw_klein.png",
  lkw_gross: "lkw_gross.png",
  lkw_anhaenger: "lkw_anhaenger.png",
});

/**
 * Liefert den vollstaendigen Public-Pfad zum Piktogramm-Bild fuer den
 * gegebenen `pictogram_key`. Unbekannte Schluessel liefern `null`
 * (fail-closed im Aufrufer: dieser rendert dann keine Karte).
 *
 * @param {string} pictogramKey Byte-stabiler Schluessel aus dem A1-Vertrag.
 * @returns {string|null}
 */
export function getVehiclePictogramSrc(pictogramKey) {
  if (!pictogramKey || typeof pictogramKey !== "string") return null;
  const file = PICTOGRAM_FILE_BY_KEY[pictogramKey];
  return file ? `${PICTOGRAM_BASE_PATH}/${file}` : null;
}

/**
 * Die byte-eingefrorenen `pictogram_key`-Werte. Reihenfolge folgt dem
 * A1-Vertrag (sort_order 1..6). Wird ausschliesslich fuer Regressions-
 * Tests des Frontend-Mappers benoetigt.
 */
export const VEHICLE_PICTOGRAM_KEYS = Object.freeze([
  "pkw",
  "pkw_anhaenger",
  "transporter",
  "lkw_klein",
  "lkw_gross",
  "lkw_anhaenger",
]);
